import { ReactElement } from 'react'
import Activity from 'account-activity-mfe'
import getMFEConfig from 'helpers/getMFEConfig'
import useHandleNavigate from 'hooks/useHandleNavigate'
import useNavigateOnRedirect from 'hooks/useNavigateOnRedirect'

import { triggerAnalyticsEvent } from 'syf-js-utilities'
import { useAtomValue } from 'jotai'
import { selectedAccountAtom } from 'store/atoms'
import ActivityTableWrapper from './subcomponents'

const ActivityPage = (): ReactElement => {
  const selectedAccount = useAtomValue(selectedAccountAtom)

  const { handleNavigate } = useHandleNavigate()

  useNavigateOnRedirect()

  const mmaConfig = getMFEConfig('mma')

  return (
    <ActivityTableWrapper>
      <Activity
        config={mmaConfig}
        guidAccountId={selectedAccount}
        navigationHandler={handleNavigate}
        triggerAnalyticsEvent={triggerAnalyticsEvent}
      />
    </ActivityTableWrapper>
  )
}

export default ActivityPage
